import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AppService, AppSettingService } from '../app.service';

@Component({
	selector: 'app-action-icon',
	templateUrl: `./action-icon.component.html`,
	styleUrls: ['./territory-card.scss'],
	standalone: false
})
export class ActionIconComponent implements OnInit {
	@Input() fontAwesomeIconClass: string = "";
	@Input() toolTip: string = "";
	@Input() iconLabel: string = "";
	@Input() isMobile: boolean = false;
	//@Output() selected = new EventEmitter<any>();
	constructor(		
	) { }

	//callback for "selected" @Output event
	//onSelect() {
	//	this.selected.emit();
	//}

	ngOnInit(): void {		
	}
}
